module.exports = __webpack_public_path__ + "static/media/1017314.be43f4c5.jpg";